import cx from "classnames";
import type { Node as $IMPORTED_TYPE$_Node } from "React";
import type { Node } from "react";
import React, { Component, lazy, Suspense } from "react";
import { FormattedMessage } from "react-intl";
import "./Modal.scss";
const AriaModal: React.LazyExoticComponent<any> = lazy(
  () => import("react-aria-modal")
);
type Props = {
  children: Node;
  modalOpen?: boolean;
  closeModal: (...args: Array<any>) => any;
  contentLabel: string;
  cancelButton?: boolean;
  className?: string;
  cancelButtonText?: string;
  underlayClickExits?: boolean;
  escapeExits?: boolean;
};
type State = {
  modalHasEntered: boolean;
};

class Modal extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      modalHasEntered: false,
    };
  }

  onModalEnter: () => void = () => {
    this.setState({
      modalHasEntered: true,
    });
  };
  onModalClose: () => void = () => {
    this.setState(
      {
        modalHasEntered: false,
      },
      () => {
        setTimeout(() => this.props.closeModal(), 300);
      }
    );
  };

  render(): $IMPORTED_TYPE$_Node {
    const {
      modalOpen,
      contentLabel,
      children,
      cancelButton,
      cancelButtonText,
      className,
      underlayClickExits,
      escapeExits,
    } = this.props;
    return (
      <Suspense fallback={<div className="fallback">loading modal...</div>}>
        <AriaModal
          mounted={modalOpen}
          onExit={this.onModalClose}
          titleText={contentLabel}
          onEnter={this.onModalEnter}
          applicationNode={document.getElementsByTagName("BODY")[0]}
          underlayColor={false}
          underlayClass={cx("modal__overlay", {
            "modal__overlay--has-entered": this.state.modalHasEntered,
          })}
          dialogClass={cx("modal", className)}
          underlayClickExits={underlayClickExits}
          escapeExits={escapeExits}
        >
          <div className="modal__no-focus" tabIndex="0">
            <div>{children}</div>
            {cancelButton && (
              <button
                className="modal__cancel-button"
                onClick={this.onModalClose}
              >
                {cancelButtonText ? (
                  cancelButtonText
                ) : (
                  <FormattedMessage tagName="span" id="button-cancel" />
                )}
              </button>
            )}
          </div>
        </AriaModal>
      </Suspense>
    );
  }
}

export default Modal;
